export const FETCH_AUCTION_SEARCH_BID_BOOK_DATA =
  "FETCH_AUCTION_SEARCH_BID_BOOK_DATA";
export const FETCH_AUCTION_SEARCH_BID_BOOK_DATA_SUCCESS =
  "FETCH_AUCTION_SEARCH_BID_BOOK_DATA_SUCCESS";
export const FETCH_AUCTION_SEARCH_BID_BOOK_DATA_FAILURE =
  "FETCH_AUCTION_SEARCH_BID_BOOK_DATA_FAILURE";
export const FETCH_AUCTION_SEARCH_BID_BOOK_DATA_EXPORT_SUCCESS =
  "FETCH_AUCTION_SEARCH_BID_BOOK_DATA_EXPORT_SUCCESS";
export const FETCH_AUCTION_SEARCH_BID_BOOK_DATA_API_CALL =
  "FETCH_AUCTION_SEARCH_BID_BOOK_DATA_API_CALL";

export const FETCH_SESSION_TIME_FOR_BID_BOOK =
  "FETCH_SESSION_TIME_FOR_BID_BOOK";
export const FETCH_SESSION_TIME_FOR_BID_BOOK_SUCCESS =
  "FETCH_SESSION_TIME_FOR_BID_BOOK_SUCCESS";
export const FETCH_SESSION_TIME_FOR_BID_BOOK_FAILURE =
  "FETCH_SESSION_TIME_FOR_BID_BOOK_FAILURE";

export const FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID =
  "FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID";
export const FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID_SUCCESS =
  "FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID_SUCCESS";
export const FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID_FAILURE =
  "FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID_FAILURE";
